export enum CouponCodeFormFieldsName {
  HAVE_COUPON_CODE = "haveCouponCode",
  COUPON_CODE = "couponCode"
}
